export default __webpack_public_path__ + "static/media/GothamSSm-ExtraLight.cd5f2eeb.woff";